<template>
  <v-card width="350" outlined elevation="4">
    <v-card-title>New user</v-card-title>
    <v-card-text>
      <v-form v-model="isValid">
        <v-text-field
          v-model="firstname"
          :counter="50"
          outlined=""
          prepend-inner-icon="mdi-account-details"
          placeholder="First name"
          required
          :rules="[(v) => !!v || 'First name is required']"
        ></v-text-field>
        <v-text-field
          v-model="lastname"
          :counter="50"
          outlined=""
          prepend-inner-icon="mdi-account-details"
          placeholder="Last name"
          required
          :rules="[(v) => !!v || 'Last name is required']"
        ></v-text-field>
        <v-text-field
          v-model="email"
          outlined=""
          prepend-inner-icon="mdi-email"
          placeholder="E-mail"
          required
          :rules="emailRules"
        ></v-text-field>
        <v-text-field
          v-model="mobile"
          outlined=""
          prepend-inner-icon="mdi-cellphone"
          placeholder="Mobile (Example: +4795142886)"
          required
          :rules="mobileRules"
        ></v-text-field>
        <!-- <v-select
                    v-model="e1"
                    :items="states"
                    prepend-icon="fa-flag"
                    menu-props="auto"
                    label="Select"
                    hide-details
                    single-line
                ></v-select> -->
        <!-- <div :class="`d-flex justify-center`"> -->
        <Flags
          v-bind="post"
          @valueChangedMethodInComponent="setValueMethodInView"
        ></Flags>
        <!-- {{valueInComponent}} -->
        <!-- </div> -->
        <v-row>
          <v-col> </v-col>
          <v-col>
            <v-btn :disabled="!isValid" color="primary" @click="submit"
              >Submit</v-btn
            >
          </v-col>
          <v-col>
            <v-btn color="lightgrey" link :to="cancellink.to">Cancel</v-btn>
          </v-col>
        </v-row>
        <v-alert type="success" :value="isAlertVisible">
          {{ statusResultMsg }}
          <v-btn class="ma-2" color="primary" link :to="{ name: 'GetProfile' }"
            >OK</v-btn
          >
        </v-alert>
        <v-alert type="warning" :value="isWarningAlertVisible">
          {{ statusResultMsg }}
        </v-alert>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "RegForm",
  data: () => ({
    // firstname: null,
    lastname: null,
    email: null,
    mobile: null,
    isValid: true,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    select: null,
    // e1: 'Norway',
    // items: [
    //     { text: 'Norway', icon: 'fa-arrow-down' },
    //     { text: 'Sweden', icon: 'fa-arrow-up' },
    //     { text: 'Germany', icon: 'fa-arrow-left' },
    //     { text: 'Other', icon: 'fa-arrow-right' },
    // ],
    //   states: [
    //     'Norway', 'Sweden', 'Germany', 'Other'
    // ],
    // flagicons: [
    //     { icon: 'mdi-alert' },
    //     { icon: 'fa-arrow-up' },
    //     { icon: 'fa-arrow-left' },
    //     { icon: 'fa-arrow-right' }
    // ],
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: { to: "/" },
    // getprofilelink: { to: "/getprofile" },
    emailRules: [
      (v) => !!v || "Email is required",
      // v => /.+@.+/.test(v) || 'E-mail must be valid'
      (v) =>
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          v
        ) || "E-mail must be valid",
    ],
    mobileRules: [
      (v) => !!v || "Mobile number is required",
      (v) => (v && v.length >= 11) || "Must have more digits and start with +",
      (v) =>
        /([+])\d+/.test(v) ||
        "Mobile number must be valid. Example: +4795142899",
    ],
    post: {
      id: 1,
      text: "Tekst i post",
    },
    // regId: Number,
    text: String,
    showComponent: Boolean,
    compValue: String,
    valueInComponent: String,
  }),

  created() {
    //this.baseUrl = 'http://localhost:3000/dbapi/' //https://pgbox.azurewebsites.net:3000/
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.firstname = null;
    this.lastname = null;
    this.email = null;
    this.mobile = null;
    this.statusResult = null;
    this.statusResultMsg = null;
    this.valueInComponent = "no";
    this.setNationCode();
  },
  methods: {
    submit() {
      var firstname = this.firstname;
      var lastname = this.lastname;
      var email = this.email;
      var mid = this.mobile;
      var countrycode = this.valueInComponent;
      var toSubmit = JSON.stringify({
        mid,
        countrycode,
        firstname,
        lastname,
        email,
      });
      const uri = this.baseUrl + "newpilot/";
      // console.log("toSubmit:", toSubmit);
      this.postRegistration(uri, toSubmit);
    },

    postRegistration(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data.Result;
          this.statusResultMsg = response.data.ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setNationCode() {
      this.post.id = 1;
      this.post.text = "no";
    },
    setValueMethodInView(value) {
      this.valueInComponent = value;
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
  },
  components: {
    Flags: () => import("@/components/Admin/Flags.vue"), //Denne rendrer ved behov <div v-if..>
  },
};
</script>